import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private $obs: Subject<boolean> = new Subject<boolean>();
  private data: boolean;
  obs(): Observable<boolean> {
    return this.$obs.asObservable();
  }
  show(): void {
    this.data = true;
    this.$obs.next(this.data);
  }
  hide(): void {
    this.data = false;
    this.$obs.next(this.data);
  }
}
